<!-- breadcrumb.component.html -->
<div class="breadcrumb-container">
  <nav aria-label="breadcrumb" *ngIf="breadcrumbs && breadcrumbs[0] && breadcrumbs[0].path.toString() != '/introduction'">
    <ol class="breadcrumb">
      <li class="breadcrumb-item" *ngFor="let breadcrumb of breadcrumbs; let isLast = last">
        <a [routerLink]="breadcrumb.path" *ngIf="!isLast && breadcrumb.path">
          {{ breadcrumb.displayKey | translate }}
        </a>
        <span *ngIf="isLast || !breadcrumb.path" [class.category-breadcrumb]="!breadcrumb.path">
          {{ breadcrumb.displayKey | translate }}
        </span>
      </li>
    </ol>
  </nav>
</div>